import { assets } from './assets.const';

export interface sidebarInterface {
  text: string;
  path?: string;
  img?: string;
  isSubMenu: boolean;
  subMenuItems?: sidebarInterface[];
}
export const sideBar: sidebarInterface[] = [
  {
    text: 'Dashboard',
    path: '/dashboard',
    img: assets.sidebarDashboardIcon,
    isSubMenu: false
  },
  {
    text: 'Manage Bookings',
    path: '/bookings',
    img: assets.PropertyIcon,
    isSubMenu: false
  },
  {
    text: 'Messages',
    path: '/chat',
    img: assets.ChatIcon,
    isSubMenu: false
  },
  // {
  //   text: 'Manage Package',
  //   path: '/packages',
  //   img: assets.PackageIcon,
  //   isSubMenu: false
  // },
  // {
  //   text: 'Manage Ticketing',
  //   path: '/ticketing',
  //   img: assets.PackageIcon,
  //   isSubMenu: false
  // },
  {
    text: 'Manage Experience',
    path: '/manage-experience',
    img: assets.ProductIcon,
    isSubMenu: true,
    subMenuItems: [
      {
        text: 'Manage Package',
        path: '/packages',
        img: assets.PackageIcon,
        isSubMenu: false
      },
      {
        text: 'Manage Homestay',
        path: '/homestay',
        img: assets.HomestayIcon,
        isSubMenu: false
      },
      {
        text: 'Manage Ticketing',
        path: '/ticketing',
        img: assets.PackageIcon,
        isSubMenu: false
      }
    ]
  },
  {
    text: 'Manage Guide',
    path: '/guide',
    img: assets.GuideIcon,
    isSubMenu: false
  },
  // {
  //   text: 'Manage Homestay',
  //   path: '/homestay',
  //   img: assets.HomestayIcon,
  //   isSubMenu: false
  // },
  // {
  //   text: 'Manage Deals',
  //   path: '/deals',
  //   img: assets.DealIcon,
  //   isSubMenu: false
  // },

  {
    text: 'Manage Payment',
    path: '/payments',
    img: assets.RevenueIcon,
    isSubMenu: false
  },

  {
    text: 'Manage Reviews',
    path: '/review',
    img: assets.ReveiwIcon,
    isSubMenu: false
  }
  // {
  //   text: 'Account Settings',
  //   path: '/settings',
  //   img: assets.CmsIcon,
  //   isSubMenu: false
  // },
  // {
  //   text: 'Logout',
  //   path: '/auth/login',
  //   img: assets.LogoutIcon,
  //   isSubMenu: false
  // }
];
